import { lazy } from 'react'

import { PATH_NEW_LOADER } from 'config/paths'

export const CalendarRoutes = [
    {
        id: 1,
        module: 'loader-calendar',
        protected: false,
        exact: true,
        path: PATH_NEW_LOADER.pages.calendar,
        component: lazy(
            () => import('containers/emulator/pages/calendar/CalendarPage'),
        ),
    },
]
